<template>
  <div class="row" style="margin-top: -100px;">
    <div class="col">

      <!-- widgets -->
      <div class="row">

        <!-- done -->
        <div class="col-4">
          <div class="card card-statistic-1">
            <div class="card-icon bg-success">
              <i class="fas fa-check"></i>
            </div>
            <div class="card-wrap">
              <div class="card-header">
                  <h4>Concluído (encerrado)</h4>
              </div>
              <div class="card-body">
                <div
                  v-if="widgetItems.done == 0 && widgetItems.loading"
                  class="spinner-border spinner-border spinner-border-sm"
                  role="status"
                ></div>
                <div v-else>{{ widgetItems.done }}</div>
              </div>
            </div>
          </div>
        </div>
       
        <!-- pending -->
        <div class="col-4">
          <div class="card card-statistic-1">
            <div class="card-icon bg-warning">
              <i class="fas fa-exclamation-triangle"></i>
            </div>
            <div class="card-wrap">
              <div class="card-header">
                  <h4>Enviados</h4>
              </div>
              <div class="card-body">
                <div
                  v-if="widgetItems.pending == 0 && widgetItems.loading"
                  class="spinner-border spinner-border spinner-border-sm"
                  role="status"
                ></div>
                <div v-else>{{ widgetItems.pending }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-4">
          <div class="card card-statistic-1">
            <div class="card-icon bg-danger">
              <i class="fas fa-exclamation-triangle"></i>
            </div>
            <div class="card-wrap">
              <div class="card-header">
                  <h4>Pendente</h4>
              </div>
              <div class="card-body">
                <div
                  v-if="widgetItems.error == 0 && widgetItems.loading"
                  class="spinner-border spinner-border spinner-border-sm"
                  role="status"
                ></div>
                <div v-else>{{ widgetItems.error }}</div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="row section-top">
        <div class="col-md-12 pad0">
          <p class="section-lead">Lista de todos itens enviados para Lavanderia!</p>
          <a href="/portal/governance/create" class="btn btn-outline-success float-right">
            <i class="fas fa-plus"></i>&nbsp;Novo
          </a>
          <a class="btn btn-outline-warning float-right" data-toggle="collapse" href="#panelFilter" role="button" aria-expanded="false" aria-controls="panelFilter">
            <i class="fas fa-filter"></i>&nbsp;Filtrar
          </a>
          <div class="dropdown float-right">
            <button class="btn btn-outline-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="fas fa-download"></i>
              Exportar
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <a class="dropdown-item" href="#" @click="exportData('pdf')">PDF</a>
              <a class="dropdown-item" href="#" @click="exportData('csv')">Excel</a>
              <!-- <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="#" @click="$refs.gridfullexport.showModal('portal_governance','portal_governance')">Completo</a> -->
            </div>
          </div>
        </div>
      </div>

      <!-- filter -->
      <div class="row">
        <div class="col-md-12">
          <div class="collapse" id="panelFilter">
            <div class="card card-body">
              <div class="row">

                <!-- company id -->
                <div class="col-md-6 mt-2">
                  <div class="form-group">
                    <label class="form-control-label">Empresa</label>
                    <v-select :options="filterCompanies" label="corporate_name" :reduce="corporate_name => corporate_name.id" v-model="filterItems.company_id" @input="validateCompany()" :disabled="_company ? true : false"></v-select>
                  </div>
                </div>

                <!-- contract -->
                <div class="col-md-6 mt-2">
                  <div class="form-group">
                    <label class="form-control-label">Contrato</label>
                    <v-select :options="filterContracts" label="corporate_name" :reduce="corporate_name => corporate_name.id" v-model="filterItems.contract_id"></v-select>
                  </div>
                </div>

                <!-- work_place_id -->
                <div class="col-md-6 mt-2">
                  <div class="form-group">
                    <label class="form-control-label">Local de Trabalho</label>
                    <v-select :options="filterWorkplaces" label="corporate_name" :reduce="corporate_name => corporate_name.id" v-model="filterItems.workplace_id" @input="validateWorkplace()"></v-select>
                  </div>
                </div>

                <!-- sublocal -->
                <div class="col-md-6 mt-2">
                  <div class="form-group">
                    <label class="form-control-label" for="input-sublocal">Sublocal</label>
                    <v-select :options="filterSublocal" label="corporate_name" :reduce="corporate_name => corporate_name.id" v-model="filterItems.sublocal_id" @input="loadSectors()"></v-select>
                  </div>
                </div>

                <!-- sector_id -->
                <div class="col-md-3 mt-2">
                  <div class="form-group">
                    <label class="form-control-label" for="input-sector_id">Setor</label>
                    <v-select :options="filterSectors" label="name" :reduce="name => name.id" v-model="filterItems.sector_id" @input="validateSector()"></v-select>
                  </div>
                </div>
                
                <!-- subsector_id -->
                <div class="col-md-3 mt-2">
                  <div class="form-group">
                    <label class="form-control-label" for="input-subsector_id">Subsetor</label>
                    <v-select :options="filterSubsectors" :reduce="name => name.id" label="name" v-model="filterItems.subsector_id"></v-select>
                  </div>
                </div>

                <!-- date -->
                <div class="col-md-3 mt-2">
                  <div class="form-group">
                    <label class="form-control-label" for="input-start_date">Data Inicial</label>
                    <input class="form-control" label="Data" type="date" v-model="filterItems.start_date"/>
                  </div>
                </div>
                <div class="col-md-3 mt-2">
                  <div class="form-group">
                    <label class="form-control-label" for="input-end_date">Data Final</label>
                    <input class="form-control" label="Data" type="date" v-model="filterItems.end_date"/>
                  </div>
                </div>
                
                <div class="col-md-12 mt-2 text-right">
                  <a class="btn btn-outline-secondary" style="margin-right: 20px;" @click="clearFilter()">LIMPAR</a>
                  <button class="btn btn-success" @click="filter()">FILTRAR</button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end filter -->

      <!-- grid -->
      <div class="row">
        <div class="col">
          <div class="card p-4">

            <!-- table -->
            <vue-good-table v-if="governanceItems.length > 0"
              :columns="tableColumns"
              :rows="governanceItems"
              :pagination-options="tablePagination"
              :search-options="{
                enabled: true,
                placeholder: 'Buscar..'
              }"
              styleClass="vgt-table"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == '_status'" class="text-center">
                  <span v-if="props.row.status === 2" class="rounded-status-warning"></span>
                  <span v-if="props.row.status === 1" class="rounded-status-success"></span>
                  <span v-if="props.row.status === 0" class="rounded-status-error"></span>
                </span>
                <span v-if="props.column.field == '_validation'" class="text-center">
                  <div v-if="props.row.users.kanban == null" class="text-danger"><i class="fas fa-exclamation-triangle" title="Kanban não configurado"></i></div>
                </span>
                <span v-if="props.column.field == '_actions'" class="actions">
                  <button class="btn btn-sm btn-outline-secondary" title="Visualizar Itens" @click="viewGovernance(props.row)">
                    <i class="far fa-eye"></i>
                  </button>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
              <template slot="pagination-bottom">
                <table-pagination-component :_options="tablePaginationOptions" @paginate="pagination"></table-pagination-component>
              </template>
            </vue-good-table>
            <div v-else class="text-center p-3 text-muted">
                <h5>Nenhum registro encontrado!</h5>
            </div>
            <!-- end table -->

            <div class="text-center p-4 text-muted" v-if="loading && governanceItems.length == 0">
              <h5>Carregando...</h5>
              <p>Aguarde até que os dados sejam carregados...</p>
            </div>

          </div>
        </div>
      </div>

    </div>
    <gridfullexport-component ref="gridfullexport"></gridfullexport-component>
  </div>
</template>

<script>
  import configData from "../../config.js";
  import ExportGrid from '../../exportgrid.js';
  export default {
    mixins: [configData, ExportGrid],
    props: ["_company"],
    data() {
      return {
        filterCompanies: [],
        filterContracts: [],
				filterWorkplaces: [],
				filterSublocal: [],
        filterSectors: [],
        filterSubsectors: [],
        filterItems: {
					company_id: null,
          contract_id: null,
          workplace_id: null,
          sublocal_id: null,
          sector_id: null,
          subsector_id: null,
          start_date: null,
          end_date: null,
				},
        governanceItems: [],
        loading: false,
        searchTerm: '',
        widgetItems: {
          done: 0,
          pending: 0,
          error: 0,
          loading: false
        },
        tablePagination: configData.tablePagination,
        tableColumns: [
          {
            label: "Status",
            field: "_status",
            sortable: false,
            width: "80px",
          },{
            label: "Empresa",
            field: "company_name"
          },{
            label: "Contrato",
            field: "contract_name"
          },{
            label: "Local de Trabalho",
            field: "workplace_name"
          },{
            label: "Sublocal",
            field: "sublocal_name"
          },{
            label: "Setor",
            field: "sector_name"
          },{
            label: "Subsetor",
            field: "subsector_name"
          },{
            label: "Aberto Por",
            field: "opened_by_name"
          },{
            label: 'Aberto Em',
            field: 'created_at',
            type: 'date',
            dateInputFormat: "yyyy-MM-dd\'T\'HH:mm:ss.SSSSSSXXX",
            dateOutputFormat: 'dd/MM/yyyy HH:mm:ss'
          },{
            label: "Fechado Por",
            field: "closed_by_name"
          },{
            label: 'Fechado Em',
            field: 'closed_at',
            type: 'date',
            dateInputFormat: "yyyy-MM-dd HH:mm:ss",
            dateOutputFormat: 'dd/MM/yyyy HH:mm:ss'
          },{
            label: "Ações",
            field: "_actions",
            width: "80px",
            sortable: false
          }
        ],
        tableColumnsItems: [
        {
            label: "Status",
            field: "_status",
            sortable: false,
            width: "80px",
          },{
            label: 'Data e Hora',
            field: 'created_at',
            type: 'date',
            dateInputFormat: "yyyy-MM-dd\'T\'HH:mm:ss.SSSSSSXXX",
            dateOutputFormat: 'dd/MM/yyyy HH:mm:ss'
          },{
            label: "Ações",
            field: "_actions",
            width: "140px"
          }
        ],
        tablePaginationOptions: {
					currentPage: 1,
					currentPerPage: 10,
					from: 0,
					to: 0,
					total: null
				},
        tablePaginationOptionsItems: {
					currentPage: 1,
					currentPerPage: 10,
					from: 0,
					to: 0,
					total: null
				},
      }
    },
    mounted() {
      if(this._company){
        this.filterItems.company_id = parseInt(this._company);
        this.validateCompany();
      }
      this.filter();
      this.loadCompanies();
    },
    methods: {
      pagination(page){
				this.tablePaginationOptions = {
					currentPage: page.options.currentPage,
					currentPerPage: page.options.currentPerPage,
					from: page.options.from,
					to: page.options.to,
					total: page.options.total
				};
				this.filter();
			},
      exportData(type){
				var tempForm = $('#vgt-table');
				if(type == 'pdf'){
					this._exportPDF('Relatório de Governança', [11], tempForm, ['Status','Empresa','Contrato','Local de Trabalho','Sublocal','Setor','Subsetor','Aberto Por','Aberto Em','Fechado Por','Fechado Em']);
				} else {
					this._exportExcel('Relatório de Governança', [11], tempForm, ['Status','Empresa','Contrato','Local de Trabalho','Sublocal','Setor','Subsetor','Aberto Por','Aberto Em','Fechado Por','Fechado Em']);
				}
    	},
      filter() {
        let _this = this;
        _this.loading = true;
				_this.governanceItems = []
				var params = {
					page: _this.tablePaginationOptions.currentPage,
					perPage: _this.tablePaginationOptions.currentPerPage,
				};
				axios.post("/portal/governance/filter", _this.filterItems, {params: params}).then((res) => {
					const { data, total, from, to } = res.data.data;
					_this.tablePaginationOptions.total = total;
					_this.tablePaginationOptions.from = from;
					_this.tablePaginationOptions.to = to;
					_this.governanceItems = [...data];
          _this.loading = false;
					this.validateWidgets();
				}).catch((err) => {
          _this.loading = false;
				});
      },
      loadCompanies() {
        let _this = this;
        axios.get("/admin/companies").then((res) => {
          res.data.sort(function(a, b){
            return a.corporate_name - b.corporate_name;
          });
          _this.filterCompanies = _this.filterCompanies.concat(res.data);
        }).catch((err) => {
        });
      },
      loadContracts() {
				let _this = this;
				_this.loading = true;
				_this.filterContracts = [];
				axios.get("/admin/companycontracts/"+_this.filterItems.company_id+"/search").then((res) => {
					res.data.map((rowContract) => {
						_this.filterContracts.push({
							id: rowContract.contract_id,
							corporate_name: rowContract.contracts.corporate_name
						});
					});
					_this.filterContracts.sort(function(a, b){
						return a.corporate_name - b.corporate_name;
					});
					_this.loading = false;
				}).catch((err) => {
					_this.loading = false;
				});
			},
      loadSectors() {
				let _this = this;
				_this.loading = true;

        _this.filterSectors = [];

        axios.get("/admin/sectors/"+_this.filterItems.sublocal_id+"/search").then((res) => {
          res.data.sort(function(a, b){
            return a.name - b.name;
          });
          _this.filterSectors = _this.filterSectors.concat(res.data);
          _this.loading = false;
        }).catch((err) => {
          _this.loading = false;
      });

			},
      validateCompany(){
				let _this = this;
				_this.loading = true;

        _this.filterWorkplaces = [];
        axios.get("/admin/companyworkplaces/"+_this.filterItems.company_id+'/search').then((res) => {
          res.data.map((rowReturn) => {
            _this.filterWorkplaces = _this.filterWorkplaces.concat(rowReturn.work_places);
          });
          _this.filterWorkplaces.sort(function(a, b){
            return a.corporate_name - b.corporate_name;
          });
          _this.loadContracts();
        }).catch((err) => {
        });
        this.loading = false;
			},
      validateSector(){
				let _this = this;
				_this.filterSubsectors = [];
				_this.loading = true;
				axios.get("/admin/subsectors/"+_this.filterItems.sublocal_id+"/search").then((res) => {
					res.data.map((rowSubsector) => {
						if(rowSubsector.sector_id == _this.filterItems.sector_id){
							_this.filterSubsectors.push(rowSubsector);
						}
					});
					_this.loading = false;
				}).catch((err) => {
					_this.loading = false;
				});
			},
      validateWidgets(){
        let _this = this;
        _this.widgetItems.loading = true;
        _this.widgetItems.done = 0;
        _this.widgetItems.pending = 0;

        axios.post("/portal/governance/widgets", this.filterItems).then((res) => {
          const { done, pending, error } = res.data;
          _this.widgetItems.done = done;
          _this.widgetItems.pending = pending;
          _this.widgetItems.error = error;
          _this.widgetItems.loading = false;
        }).catch((err) => {
          _this.widgetItems.loading = false;
        });
      },
      validateWorkplace(){
				let _this = this;

        _this.filterSublocal = [];
        axios.get("/admin/workplacesublocal/"+_this.filterItems.workplace_id+"/search").then((res) => {
          res.data.map((rowSublocal) => {
            _this.filterSublocal.push({
              corporate_name: rowSublocal.sublocal.corporate_name,
              id: rowSublocal.sublocal_id
            });
          });
          _this.loading = false;
        }).catch((err) => {
          _this.loading = false;
        });

			},
      viewGovernance(item){
        location.href = "/portal/governance/view/"+item.hash;
      }
    }
  }
</script>
